module.exports = __webpack_public_path__ + "img/info-red.c8395673.svg";